export default defineNuxtRouteMiddleware((_to, from) => {
        const { user } = useCredentials()
        if (user.value) return
        if (from && from.path.startsWith("/admin")) return navigateTo("/admin/login")
        return navigateTo("/users/sign_in")
})
